import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsTagSelectorComponent } from "./ds-tag-selector.component";
import { DsSelectorComponentsModule } from "../ds-selector-components/ds-selector-components.module";
import { DsIconModule } from "../ds-icon/ds-icon.module";
@NgModule({
  declarations: [DsTagSelectorComponent],
  imports: [CommonModule, DsSelectorComponentsModule, DsIconModule],
  exports: [DsTagSelectorComponent, DsSelectorComponentsModule],
})
export class DsTagSelectorModule {}
